{
	"chart": {
		"showTable": "Show as table",
		"showChart": "Show as chart"
	},
	"medal": {
		"gold": "Gold",
		"silver": "Silver",
		"bronze": "Bronze"
	},
	"series": {
		"men": "Men",
		"women": "Women",
		"officials": "Officials",
		"implied": "Athletes implied (EBN)",
		"entries": "Entries (EBN)",
		"estEntries": "Estimated entries (EOI)",
		"quota": "Quota"
	},
	"table": {
		"sport": "Sport",
		"nocs": "NOCs interested",
		"events": "Events with interest",
		"event": "Event",
		"picked": "Picked explicitly",
		"perNoc": "Quota per NOC",
		"noc": "NOC",
		"total": "Total",
		"day": "Day"
	},
	"tabs": {
		"title": "Details",
		"label": "Detail views",
		"matrix": "Matrix",
		"strength": "Strength map"
	},
	"filters": {
		"nocs": "Filter by NOC",
		"allNocs": "All NOCs",
		"sport": "Filter by sport",
		"allSports": "All sports",
		"active": "Active filters",
		"sportChip": "Sport: {{sport}}",
		"nocChip": "NOC: {{noc}}",
		"remove": "Remove filter {{name}}",
		"unknownNoc": "Unknown NOC",
		"clear": "Clear filters"
	},
	"state": {
		"loadFailed": "Couldn't load the statistics",
		"tryAgain": "Try again",
		"stale": "Couldn't refresh the statistics; showing the last numbers.",
		"noNocsTitle": "No NOCs to show",
		"noNocsHint": "No NOC organisation matches these filters for this games."
	},
	"kpi": {
		"aria": "Headline numbers",
		"of": "of {{n}}",
		"shareMeter": "{{pct}} with interest",
		"athletes": "Athletes",
		"medals": "Medals expected",
		"medalsOnOffer": "of {{n}} on offer",
		"split": "{{men}} men · {{women}} women",
		"medalsAria": "{{g}} gold, {{s}} silver, {{b}} bronze expected",
		"overOfferMedal": "! {{medal}}: {{pct}} of offer",
		"delegation": "Est. delegation",
		"delegationSplit": "{{athletes}} athletes · {{officials}} officials",
		"programme": "Programme coverage",
		"sportsShort": "Sports",
		"eventsShort": "Events",
		"men": "{{n}} men",
		"women": "{{n}} women",
		"entries": "Entries (EBN)",
		"entriesSplit": "{{events}} events · {{implied}} athletes implied"
	},
	"sports": {
		"title": "Sports by interest",
		"desc": {
			"EOI": "Estimated athletes per sport, men and women, with the NOCs interested. Pick a sport to filter the page.",
			"EBN": "Athletes implied by the EBN entries per sport, with the NOCs interested. Pick a sport to filter the page."
		},
		"tip": {
			"nocs": "NOCs interested",
			"ofNocs": "{{n}} of {{of}}",
			"events": "Events with interest",
			"ofEvents": "{{n}} of {{of}}",
			"pick": "Click to filter the page by this sport",
			"clear": "Click to clear the sport filter"
		},
		"sort": {
			"label": "Sort sports",
			"interest": "Most NOCs first",
			"athletes": "Most athletes first",
			"medals": "Most medals first",
			"entries": "Most entries first",
			"programme": "Programme order",
			"name": "By name"
		},
		"legendNoc": "One dot per NOC interested",
		"empty": "This games has no sports yet.",
		"noInterest": "No NOC has expressed interest in a sport yet.",
		"rowAria": {
			"EOI": "{{sport}}: {{nocs}} NOCs interested, {{men}} men and {{women}} women estimated",
			"EBN": "{{sport}}: {{nocs}} NOCs interested, {{implied}} athletes implied by the entries"
		},
		"nocsShort_one": "{{n}} NOC",
		"nocsShort_other": "{{n}} NOCs",
		"showAll": "Show all {{n}} sports",
		"showWanted": "Show only sports with interest"
	},
	"events": {
		"title": "{{sport}}: interest against the quota",
		"desc": "Per event: the entries the interested NOCs estimated and entered, against the quota for those NOCs.",
		"descOver_one": "{{n}} event has more estimated entries than its quota allows.",
		"descOver_other": "{{n}} events have more estimated entries than their quota allows.",
		"close": "Close",
		"empty": "This sport has no events yet.",
		"noQuota": "No quota",
		"overQuota": "Over quota",
		"nocs": "{{n}} of {{of}} NOCs",
		"rowAria": "{{event}}: {{nocs}} NOCs interested, {{est}} entries estimated, quota {{cap}}, {{entries}} entered",
		"tip": {
			"nocs": "NOCs interested",
			"nocsValue": "{{n}} of {{of}} ({{picked}} picked it)",
			"ebnNocs": "NOCs entered (EBN)",
			"perNoc": "Quota per NOC",
			"medals": "Medals expected",
			"medalsValue": "{{g}} gold · {{s}} silver · {{b}} bronze"
		}
	},
	"nocs": {
		"empty": "No NOC in these filters yet.",
		"tip": {
			"focus": "Click to focus the page on this NOC",
			"unfocus": "Click to show every NOC again"
		}
	},
	"funnel": {
		"stage": {
			"eoi": "EOI estimate",
			"ebn": "EBN implied",
			"short": "Shortlisted"
		},
		"title": "From interest to entries",
		"desc": "Athletes per NOC: estimated in the EOI, implied by the EBN, shortlisted. Pick a NOC to focus the page.",
		"ebnOfEoi": "EBN vs EOI",
		"shortOfEbn": "Shortlist vs EBN",
		"empty": "No NOC has given athlete numbers yet.",
		"without_one": "{{n}} other NOC has no numbers yet.",
		"without_other": "{{n}} other NOCs have no numbers yet.",
		"rowAria": "{{noc}}: {{eoi}} estimated, {{ebn}} implied by the EBN, {{short}} shortlisted"
	},
	"dashboard": {
		"subtitle": "Expression of interest and entry by number, all NOCs"
	},
	"progress": {
		"title": "Who has answered",
		"desc": "Submissions per phase across the NOCs in view.",
		"ofSubmitted": "of {{n}} submitted",
		"barAria": "{{phase}}: {{final}} submitted, {{open}} in progress, {{none}} not started, of {{total}} NOCs",
		"final": "{{n}} submitted",
		"open": "{{n}} in progress",
		"none": "{{n}} not started",
		"deadline": "Next deadline: {{at}}",
		"waitingOn_one": "Waiting on {{count}} NOC",
		"waitingOn_other": "Waiting on {{count}} NOCs",
		"allIn": "{{phase}}: every NOC has submitted",
		"waitingPhase": "Show who is missing for",
		"focusNoc": "{{noc}}, {{state}}. Focus the dashboard on this NOC",
		"more": "+{{n}} more",
		"fewer": "Show fewer"
	},
	"insights": {
		"title": "Things to check",
		"descAttention_one": "{{count}} item needs a look.",
		"descAttention_other": "{{count}} items need a look.",
		"descCalm": "Nothing needs attention right now.",
		"empty": "Insights appear once NOCs start sending numbers.",
		"check": "Check:",
		"medalsOverOffer": "NOCs expect {{expected}} {{medal}} medals, but only {{offer}} are on offer ({{pct}}).",
		"noAthleteNumbers_one": "{{count}} NOC submitted its EOI without athlete numbers: {{nocs}}",
		"noAthleteNumbers_other": "{{count}} NOCs submitted their EOI without athlete numbers: {{nocs}}",
		"andMore": "(+{{n}} more)",
		"ebnAbove": "EBN entries imply {{ebn}} athletes, {{pct}} of the {{eoi}} estimated in the EOI.",
		"ebnBelow": "EBN entries imply only {{ebn}} athletes, {{pct}} of the {{eoi}} estimated in the EOI.",
		"topSport": "Most wanted sport: {{sport}}, {{nocs}} of {{of}} NOCs, {{athletes}} athletes estimated.",
		"sportsWithout_one": "{{n}} of {{total}} sports has no NOC interested yet.",
		"sportsWithout_other": "{{n}} of {{total}} sports have no NOC interested yet.",
		"womenShare": "Women are {{pct}} of the estimated athletes ({{women}} of {{athletes}})."
	},
	"timeline": {
		"title": "Submissions over time",
		"desc": "NOCs that have submitted so far, per phase. The gap to the top is who is still out.",
		"empty": "No NOC has submitted yet.",
		"aria": "Submissions from {{from}} to {{to}}: {{eoi}} EOI and {{ebn}} EBN of {{of}} NOCs",
		"tipValue": "{{total}} of {{of}} (+{{day}} that day)",
		"submittedThatDay": "{{phase}} submitted that day",
		"total": "{{phase}} in total",
		"endLabel": "{{phase}} {{n}}"
	},
	"nocTable": {
		"title": "NOC comparison",
		"desc": "Every NOC's numbers side by side. Click a column to sort, a NOC to focus the page on it.",
		"foot": "— means none given yet. Delegation = athletes + officials estimated in the EOI.",
		"sortBy": "Sort by {{col}}",
		"open": "Open",
		"mw": "{{m}} M · {{w}} W",
		"medalsTotal": "{{g}} · {{s}} · {{b}}",
		"col": {
			"name": "NOC",
			"eoi": "EOI",
			"ebn": "EBN",
			"sports": "Sports",
			"events": "Events",
			"athletes": "Athletes",
			"officials": "Officials",
			"delegation": "Delegation",
			"medals": "Medals",
			"entries": "Entries",
			"implied": "Implied",
			"shortlisted": "Shortlisted"
		}
	}
}
